import datejs from '../static/js/date.js'

export default {
  pickerShortcuts: [
    {
      text: 'Today',
      onClick(picker) {
        picker.$emit('pick', [Date.today(), Date.today()]);
      }
    },
    {
      text: 'Yesterday',
      onClick(picker) {
        picker.$emit('pick', [Date.today().addDays(-1), Date.today().addDays(-1)]);
      }
    },
    {
      text: 'Current Week',
      onClick(picker) {
        picker.$emit('pick', [Date.last().sunday().addDays(1), Date.today()]);
      }
    },
    {
      text: 'Last Week',
      onClick(picker) {
        picker.$emit('pick', [Date.last().sunday().addDays(-6), Date.last().sunday()]);
      }
    },
    {
      text: 'MTD',
      onClick(picker) {
        picker.$emit('pick', [Date.today().moveToFirstDayOfMonth(), Date.today()]);
      }
    },
    {
      text: 'Last Month',
      onClick(picker) {
        picker.$emit('pick', [Date.today().addMonths(-1).moveToFirstDayOfMonth(), Date.today().addMonths(-1).moveToLastDayOfMonth()]);
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/picker-shortcuts.js